import { motion, useMotionValue, useTransform } from 'framer-motion';
import React from 'react';
import './HoverableCard.module.scss';

export default function HoverableCard({ style, children }) {
    // Tutorial 1
    // https://iamwlad.com/blog/2-perspective-button

    // const [angle, setAngle] = React.useState(10);

    // const y = useMotionValue(0.5);
    // const x = useMotionValue(0.5);

    // const rotateY = useTransform(x, [0, 1], [-angle, angle], {
    //     clamp: true,
    // });
    // const rotateX = useTransform(y, [0, 1], [angle, -angle], {
    //     clamp: true,
    // });

    // const onMove = (e) => {
    //     // get position information for the card
    //     const bounds = e.currentTarget.getBoundingClientRect();

    //     // set x,y local coordinates
    //     const xValue = (e.clientX - bounds.x) / e.currentTarget.clientWidth;
    //     const yValue = (e.clientY - bounds.y) / e.currentTarget.clientHeight;

    //     // update MotionValues
    //     x.set(xValue, true);
    //     y.set(yValue, true);
    // };

    // tutorial 2
    // https://www.youtube.com/watch?v=cPKiilXlHAQ

    const y = useMotionValue(0);
    const x = useMotionValue(0);
    const rotateX = useTransform(y, [-50, 50], [15, -15]);
    const rotateY = useTransform(x, [-50, 50], [-15, 15]);

    return (
        <>
            <div style={{ ...style }} styleName="wrapper">
                <motion.div
                    // tutorial 1
                    // style={{
                    //     rotateY,
                    //     rotateX,
                    // }}
                    // onPointerMove={onMove}
                    // onMouseLeave={() => {
                    //     x.set(0.5), y.set(0.5);
                    // }}

                    // tutorial 2
                    style={{ x, y, rotateX, rotateY, z: 5 }}
                    drag
                    dragElastic={0.16}
                    dragConstraints={{ top: 0, left: 0, right: 0, bottom: 0 }}
                    whileTap={{ cursor: 'grabbing' }}
                >
                    {children}
                </motion.div>
            </div>
        </>
    );
}
